<template>
    <section class="qrcode-checkout-unset">
      <FloatingHeader :title="'Ler QR Code'" :sbtitle="''" :showHeader="true" :hideSearch="true" :hideArrowBack="true"></FloatingHeader>
      <div class="info-text">
        <div class="header">
          <img class="logo" :src="require('@/assets/logo/logo.png')">
        </div>
        <p>Para continuar, escaneie o QR Code relacionado ao produto que deseja comprar.</p>
        <p>Após escanear, você será redirecionado para a tela de confirmação.</p>
      </div>
    </section>
</template>

<script>
import FloatingHeader from '@/components/FloatingHeader.vue'

export default {
  name: 'ReadQrCodeView',
  components: {
    FloatingHeader
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {},
  mounted () {
  }
}
</script>

<style lang="less" scoped>
.qrcode-checkout-unset {
    padding: 60px 20px 170px 20px;

    .logo {
      width: 130px;
    }

    .info-text {
        margin: auto;
        text-align: center;
        font-size: 16px;
        top: 50%;
        position: absolute;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 16px;
        p {
            margin-bottom: 10px;
        }
    }
}
</style>
